module.exports = __webpack_public_path__ + "static/media/online.1a32af80.svg";